import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { toast } from "react-toastify";
import { useForm } from 'react-hook-form';
import axios from 'axios';

const ContactModal = ({ contactModal, SetContactModal }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [loading, setLoading] = useState(false);
  const onSubmit = (data) => {
    setLoading(true); // start loading

    axios.post(`${process.env.REACT_APP_BASE_URL}contact-us`, {
      fname: data.firstName,
      lname: data.lastName,
      email: data.email,
      phone: data.phone,
      text: data.message
    })
      .then((response) => {
        toast.success("Thank you for reaching us", { autoClose: 2000 });
        SetContactModal(false);
        reset();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Something went wrong. Please try again.", { autoClose: 2000 });
      })
      .finally(() => {
        setLoading(false); // stop loading
      });
  };

  return (
    <>
      <Modal
        show={contactModal}
        onHide={() => SetContactModal(false)}
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Fill the form to reach you</Modal.Title>
        </Modal.Header>
        <Modal.Body className='contact-us'>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className='d-flex'>
              <div className="w-auto d-flex align-items-center">
                <input
                  className='inpt_box'
                  placeholder='First Name'
                  {...register('firstName', { required: 'First Name is required' })}
                />
                {errors.firstName && <p className="sap-error-val m-1">{errors.firstName.message}</p>}
              </div>

              <div className="w-auto ms-3 d-flex align-items-center">
                <input
                  className='inpt_box'
                  placeholder='Last Name'
                  {...register('lastName', { required: 'Last Name is required' })}
                />
                {errors.lastName && <p className="sap-error-val m-1">{errors.lastName.message}</p>}
              </div>
            </div>

            <div className='d-flex mt-3'>
              <div className="w-auto d-flex align-items-center">
                <input
                  className='inpt_box'
                  placeholder='Email'
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
                      message: 'Invalid email address'
                    }
                  })}
                />
                {errors.email && <p className="sap-error-val m-1">{errors.email.message}</p>}
              </div>

              <div className="w-auto ms-3 d-flex align-items-center">
                <input
                  className='inpt_box'
                  placeholder='Phone'
                  maxLength={10}
                  {...register('phone', {
                    required: 'Phone is required',
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: 'Enter a valid 10-digit phone number'
                    }
                  })}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, '');
                  }}
                />
                {errors.phone && <p className='sap-error-val m-1'>{errors.phone.message}</p>}
              </div>
            </div>

            <div className="mt-3 mb-3 d-flex justify-content-center align-items-center">
              <input
                className='inpt_box_lst pb-2'
                placeholder='Message'
                {...register('message', { required: 'Message is required' })}
              />
              {errors.message && <p className='sap-error-val m-1'>{errors.message.message}</p>}
            </div>

            <div className="review-sec text-center">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ContactModal;
